// Polish translations
const pl = {
  translation: {
    // Common
    'app.name': 'Zdalny Monitoring',
    'app.login': 'Logowanie',
    'app.loginDemo': 'Demo Logowanie',
    'app.register': 'Rejestracja',
    'app.logout': 'Wyloguj',
    'common.dashboard': 'Pulpit',
    'common.installations': 'Instalacje',
    'app.news': 'Aktualności',
    'news.overview': 'Przegląd newsów',
    'news.searchPlaceholder': 'Szukaj wiadomości...',
    'news.searchButton': 'Szukaj',
    'news.noNewsFound': 'Nie znaleziono wiadomości.',
    'app.shop': 'Sklep',

    // Gallery
    'gallery.title': 'Galeria Instalacji',
    'gallery.share': 'Udostępnij',
    'gallery.shared': 'Udostępniono',
    'gallery.pending': 'Oczekuje',
    'gallery.noImages': 'Brak zdjęć',
    'gallery.like': 'Lubię to',
    'gallery.loginToLike': 'Zaloguj się',
    'gallery.loadError': 'Błąd ładowania',
    'common.uploadImagesSuccess': 'Wysłano',
    'common.uploadImagesFailed': 'Błąd wysyłania',
    'gallery.deleteConfirm': 'Usunąć zdjęcie?',
    'gallery.maxImages': 'Max {{max}} zdjęć',
    'gallery.caption': 'Opis',
    'gallery.selectInstallation': 'Wybierz instalację',
    'gallery.selectFiles': 'Wybierz pliki',
    'gallery.filesSelected': '{{count}} plików',
    'gallery.selectInstallationAndFiles': 'Wybierz instalację i pliki',
    'gallery.shareToGallery': 'Udostępnij publicznie',
    'gallery.myImages': 'Moje Zdjęcia',
    'gallery.publicGallery': 'Galeria Publiczna',
    'gallery.unshare': 'Cofnij udost.',
    'gallery.unshared': 'Cofnięto',
    'gallery.subtitle': 'Podziel się instalacją',
    'gallery.dropOrClick': 'Przeciągnij lub kliknij',
    'gallery.private': 'Prywatne',
    'gallery.selectSource': 'Wybierz źródło',
    'gallery.takePhoto': 'Zrób Zdjęcie',
    'gallery.chooseFromGallery': 'Z Galerii',
    'gallery.captionPlaceholder': 'Opisz instalację...',
    'gallery.shareHint': 'Pozwól innym zobaczyć',
    'common.uploadImagesHint': 'JPG, PNG (max 10MB)',

    'common.devices': 'Urządzenia',
    'app.profile': 'Profil',
    'common.settings': 'Ustawienia',
    'settings.verificationCode': 'Kod weryfikacyjny',
    'settings.sendCode': 'Wyślij kod',
    'settings.codeSentNotice': 'Kod weryfikacyjny został wysłany na Twój e-mail',
    'settings.codeRequired': 'Wprowadź 6-cyfrowy kod weryfikacyjny',
    'app.language': 'Język',

    'app.email': 'Email',
    'common.password': 'Hasło',
    'app.username': 'Nazwa użytk.',
    'app.confirmPassword': 'Potwierdź Hasło',
    'app.submit': 'Wyślij',
    'common.cancel': 'Anuluj',
    'common.save': 'Zapisz',
    'common.set': 'Zapisz',
    'common.delete': 'Usuń',
    'common.add': 'Dodaj',
    'common.upload': 'Wyślij',
    'common.edit': 'Edytuj',
    'common.search': 'Szukaj',
    'common.filter': 'Filtruj',
    'common.sort': 'Sortuj',
    'common.status': 'Status',
    'common.online': 'Online',
    'common.offline': 'Offline',
    'common.error': 'Błąd',
    'common.success': 'Sukces',
    'app.back': 'Wstecz',
    'app.home': 'Strona Gł.',
    'common.actions': 'Akcje',
    'common.loading': 'Ładowanie...',
    'common.processing': 'Przetwarzanie...',
    'common.close': 'Zamknij',
    'common.units': 'Jednostki',
    'common.normal': 'Normalny',
    'common.tooHigh': 'Za Wysoka',
    'common.tooLow': 'Za Niska',
    'common.number': 'Numer',
    'common.time': 'Czas',
    'common.overview': 'Przegląd',
    'common.details': 'Szczegóły',
    'common.rowsPerPage': 'Wierszy/stronę',
    'common.readMore': 'Czytaj więcej',
    // Unified terms (reuse across pages)
    'common.voltage': 'Napięcie',
    'common.current': 'Prąd',
    'common.power': 'Moc',
    'common.temperature': 'Temperatura',
    'common.soc': 'SOC',
    'common.charging': 'Ładowanie',
    'common.discharging': 'Rozładow.',
    'common.idle': 'Bezczynny',
    'common.warning': 'Ostrzeżenie',
    'common.warnState1': 'Ostrz. Stan 1',
    'common.warnState2': 'Ostrz. Stan 2',
    'common.cell': 'Ogniwo',
    'common.avgVoltage': 'Śr. Napięcie',
    'common.avgTemperature': 'Śr. Temperatura',
    'common.totalCurrent': 'Całk. Prąd',
    'common.totalPower': 'Całk. Moc',
    'common.fullyCharged': 'Naładowany',
    'common.user': 'Użytkownik',
    'common.deviceId': 'ID Urządzenia',
    'common.unknownWarning': 'Nieznane Ostrz.',
    'common.admin': 'Admin',
    'common.protection': 'Ochrona',
    'common.fault': 'Usterka',
    'common.calibration': 'Kalibracja',
    'common.refresh': 'Odśwież',
    'common.addDevice': 'Dodaj Urządzenie',
    'common.deviceAdded': 'Dodano urządzenie',
    'common.cycleCount': 'Cykle',
    'common.soh': 'SOH',
    'common.realtime': 'Monitor. Real-time',
    'common.batteryPackTitle': 'Pakiet #{{index}}',
    'common.remainCapacityAh': 'Pojem. Pozost. (Ah)',
    'common.fullChargeCapacityAh': 'Pojem. Pełna (Ah)',
    'common.designCapacityAh': 'Pojem. Nominal. (Ah)',
    'common.backToDetail': 'Wróć do Instalacji',
    'common.loadDeviceFailed': 'Błąd ładowania urządzenia',
    'common.permissionsManagement': 'Zarządz. Uprawnieniami',
    'common.shortCircuitProt': 'Ochrona Zwarciowa',
    'common.startDate': 'Data Początkowa',
    'common.endDate': 'Data Końcowa',
    // Status & States
    'common.expired': 'Wygasło',
    // Actions
    'common.create': 'Utwórz',
    // Time-related
    'common.day': 'dzień',
    'common.days': 'dni',
    'common.createdAt': 'Utworzono',
    'common.expiry': 'Data Ważności',
    'common.expiryDays': 'Okres Ważności (dni)',
    // Battery-related
    'common.batteryPack': 'Pakiet Baterii',
    'common.dischargeEnabled': 'Rozładow. Włączone',
    'common.chargeEnabled': 'Ładowanie Włączone',
    'common.currentLimit': 'Limit Prądu',
    'common.charger': 'Ładowarka',
    'common.avg': 'Średnia',


    // Device
    'device.lastConnection': 'Ostatnie Połączenie',
    'device.delete': 'Usuń Instalację',
    'device.view': 'Zobacz Urządzenie',
    'device.notFound': 'Nie znaleziono urządzenia',
    'device.deleteSuccess': 'Instalacja usunięta',
    'device.confirmDelete': 'Usunąć tę instalację?',
    'device.info': 'Informacje o Instalacji',
    'device.details': 'Szczegóły Urządzenia',
    'device.never': 'Nigdy',
    'device.errorMissingFields': 'Wypełnij wymagane pola',
    'device.idHelp': 'Wprowadź unikalne ID urządzenia',
    'device.nameHelp': 'Nazwij swoje urządzenie',
    'device.loading': 'Ładowanie urządzeń...',
    'common.justNow': 'Przed chwilą',
    'device.minutesAgo': 'min temu',
    'device.hoursAgo': 'godz. temu',
    'device.noDevicesDesc': 'Nie masz jeszcze urządzeń. Kliknij poniżej, aby dodać pierwsze.',
    'device.deleting': 'Usuwanie...',
    'device.noConnections': 'Brak ostatnich połączeń',
    'device.type': 'Typ Urządzenia',
    'device.optionalInfo': 'Informacje Opcjonalne',
    'device.optionalInfoTooltip': 'Te informacje pomagają nam zapewnić lepszą obsługę',
    'device.inverterBrand': 'Marka Falownika',
    'device.inverterModel': 'Model Falownika',
    'device.solarPower': 'Moc Solar (kW)',
    'device.city': 'Miasto Instalacji',
    'device.description': 'Opis Instalacji',
    'device.updatedAt': 'Zaktualizowano',

    // Battery data
    'battery.status': 'Status Ładowania',
    'battery.data': 'Dane Baterii',
    'battery.history': 'Historia',
    'battery.protectionRecord': 'Rekordy Ochrony',
    'battery.balance': 'Prąd Balansowania',
    'battery.cells': 'Liczba Ogniw',
    'battery.noData': 'Brak danych',
    'battery.historyCharts': 'Wykresy Historii',
    'battery.resetZoom': 'Reset',

    'battery.cellData': 'Dane Ogniw',
    'battery.cellVoltageData': 'Napięcia Ogniw',
    'battery.temperatureData': 'Dane Temperatur',
    'battery.cellDataUnavailable': 'Dane ogniw tymczasowo niedostępne, wyświetlam poprzednie dane...',
    'battery.tempDataUnavailable': 'Dane czujników temp. tymczasowo niedostępne, wyświetlam poprzednie dane...',
    'battery.cellVoltageTable': 'Tabela Napięć Ogniw',
    'battery.tempDataTable': 'Tabela Temperatur',
    'battery.cellStats': 'Statystyki Ogniw',
    'battery.activeBalancing': 'Aktywne Balansowanie',
    'battery.activeBalancingOn': 'Balansowanie',
    'battery.heaterEnabled': 'Grzanie Włączone',
    'battery.currentLimitEnabled': 'Limit Prądu Wł.',
    'battery.highest': 'Najwyższa',
    'battery.lowest': 'Najniższa',
    'battery.highestVoltage': 'Najw. Napięcie',
    'battery.lowestVoltage': 'Najmn. Napięcie',
    'battery.volDiff': 'Różnica Napięć',
    'battery.totalCells': 'Ogniw Razem',
    'battery.temperatureSensors': 'Czujniki Temp.',
    'battery.temperatureStats': 'Statystyki Temp.',
    'battery.sensorCount': 'Liczba Czujników',
    'battery.highestTemperature': 'Najw. Temperatura',
    'battery.lowestTemperature': 'Najmn. Temperatura',
    'battery.faultState': 'Stan Usterki',
    'battery.protectState1': 'Ochrona Stan 1',
    'battery.protectState2': 'Ochrona Stan 2',

    // Warning titles
    'warning.title': 'Informacje Ostrzegawcze',
    'warning.current': 'Aktualne Ostrzeżenia',
    'warning.normal': 'Status baterii normalny, brak ostrzeżeń',
    'warning.noWarning': 'Brak Ostrzeżenia',

    // Warning states

    // Protection state related
    'warning.protect_high_discharge_current': 'Ochrona Prądu Rozładowania',
    'warning.protect_high_charge_current': 'Ochrona Prądu Ładowania',
    'warning.protect_low_total_voltage': 'Ochrona Niskiego Napięcia',
    'warning.protect_high_total_voltage': 'Ochrona Wysokiego Napięcia',
    'warning.protect_low_cell_voltage': 'Ochrona Niskiego Napięcia Ogniw',
    'warning.protect_high_cell_voltage': 'Ochrona Wysokiego Napięcia Ogniw',
    'warning.protect_low_env_temp': 'Ochrona Niskiej Temp. Otoczenia',
    'warning.protect_high_env_temp': 'Ochrona Wysokiej Temp. Otoczenia',
    'warning.protect_high_mos_temp': 'Ochrona Wysokiej Temp. MOS',
    'warning.protect_low_discharge_temp': 'Ochrona Niskiej Temp. Rozładowania',
    'warning.protect_low_charge_temp': 'Ochrona Niskiej Temp. Ładowania',
    'warning.protect_high_discharge_temp': 'Ochrona Wysokiej Temp. Rozładowania',
    'warning.protect_high_charge_temp': 'Ochrona Wysokiej Temp. Ładowania',

    // Command state related
    'battery.reverse_connected': 'Odwrócone Podłączenie Baterii',

    // Fault state related
    'warning.fault_sampling': 'Usterka Próbkowania',
    'warning.fault_cell': 'Usterka Ogniwa',
    'warning.fault_ntc': 'Usterka Czujnika Temperatury',
    'warning.fault_discharge_mos': 'Usterka MOS Rozładowania',
    'warning.fault_charge_mos': 'Usterka MOS Ładowania',
    'warning.fault_adapter_temp': 'Przegrzanie Płyty Adaptera',
    'warning.fault_virtual_connection': 'Wirtualne Połączenie Baterii',
    'warning.fault_communication': 'Usterka Komunikacji',
    'warning.fault_ccb': 'Usterka CCB',
    'warning.fault_heater': 'Usterka Grzałki',
    'warning.fault_12v': 'Usterka Zasilania 12V',
    'warning.fault_total_voltage': 'Usterka Napięcia Całkowitego',
    'warning.fault_temp_diff': 'Usterka Różnicy Temperatur',
    'warning.fault_detect_resistor': 'Usterka Rezystora Detekcji',
    'warning.fault_trip_unit': 'Usterka Jednostki Wyłączającej',
    'warning.fault_master_slave': 'Usterka Komunikacji Master/Slave',
    'warning.fault_bms_lock': 'BMS Zablokowany',
    'warning.fault_mcu_overvoltage': 'Przepięcie MCU',

    'warning.protect_short_circuit': 'Ochrona Zwarcia',
    'warning.protect_charger_overvoltage': 'Ochrona Przepięcia Ładowarki',
    'warning.protect_full_charge': 'Ochrona Pełnego Naładowania',

    // Status indicators
    'status.limit_current_on': 'Limit Prądu WŁ.',
    'status.limit_current_off': 'Limit Prądu WYŁ.',
    'status.charge_mos_on': 'MOS Ładow. WŁ.',
    'status.charge_mos_off': 'MOS Ładow. WYŁ.',
    'status.discharge_mos_on': 'MOS Rozładow. WŁ.',
    'status.discharge_mos_off': 'MOS Rozładow. WYŁ.',
    'status.charger_connected': 'Ładowarka Podłączona',
    'status.charger_disconnected': 'Ładowarka Odłączona',
    'status.heater_on': 'Grzanie WŁ.',
    'status.heater_off': 'Grzanie WYŁ.',

    // Warning state 1 related
    'warning.warn_high_discharge_current': 'Ostrz. Prąd Rozładowania',
    'warning.warn_high_charge_current': 'Ostrz. Prąd Ładowania',
    'warning.warn_low_total_voltage': 'Ostrz. Niskie Napięcie',
    'warning.warn_high_total_voltage': 'Ostrz. Wysokie Napięcie',
    'warning.warn_low_cell_voltage': 'Ostrz. Niskie Napięcie Ogniw',
    'warning.warn_high_cell_voltage': 'Ostrz. Wysokie Napięcie Ogniw',

    // Warning state 2 related
    'warning.warn_low_soc': 'Ostrz. Niski SOC',
    'warning.warn_high_mos_temp': 'Ostrz. Temp. MOS',
    'warning.warn_low_env_temp': 'Ostrz. Niska Temp. Otocz.',
    'warning.warn_high_env_temp': 'Ostrz. Wysoka Temp. Otocz.',
    'warning.warn_low_discharge_temp': 'Ostrz. Niska Temp. Rozładow.',
    'warning.warn_low_charge_temp': 'Ostrz. Niska Temp. Ładow.',
    'warning.warn_high_discharge_temp': 'Ostrz. Wysoka Temp. Rozładow.',
    'warning.warn_high_charge_temp': 'Ostrz. Wysoka Temp. Ładow.',

    // Warning states
    'warning.below_lower_limit': 'Poniżej Limitu',
    'warning.above_upper_limit': 'Powyżej Limitu',
    'warning.user_defined': 'Ostrz. Użytkownika',
    'warning.other_fault': 'Inna Usterka',

    // Warning descriptions (for tooltip)
    'warningDesc.warn_low_soc': 'Poziom naładowania baterii (SOC) jest poniżej bezpiecznego progu, proszę naładować w odpowiednim czasie',
    'warningDesc.warn_high_mos_temp': 'Temperatura MOS jest zbyt wysoka, co może wpłynąć na wydajność ładowania/rozładowania',
    'warningDesc.warn_low_env_temp': 'Temperatura otoczenia jest zbyt niska, co może wpłynąć na wydajność baterii',
    'warningDesc.warn_high_env_temp': 'Temperatura otoczenia jest zbyt wysoka, proszę zwrócić uwagę na odprowadzanie ciepła',
    'warningDesc.warn_low_discharge_temp': 'Temperatura rozładowania jest zbyt niska, rozładowanie zostało ograniczone',
    'warningDesc.warn_low_charge_temp': 'Temperatura ładowania jest zbyt niska, ładowanie zostało ograniczone',
    'warningDesc.warn_high_discharge_temp': 'Temperatura rozładowania jest zbyt wysoka, rozładowanie zostało ograniczone',
    'warningDesc.warn_high_charge_temp': 'Temperatura ładowania jest zbyt wysoka, ładowanie zostało ograniczone',
    'warningDesc.warn_high_discharge_current': 'Prąd rozładowania przekracza limit bezpieczeństwa',
    'warningDesc.warn_high_charge_current': 'Prąd ładowania przekracza limit bezpieczeństwa',
    'warningDesc.warn_low_total_voltage': 'Napięcie całkowite jest poniżej progu bezpieczeństwa',
    'warningDesc.warn_high_total_voltage': 'Napięcie całkowite jest powyżej progu bezpieczeństwa',
    'warningDesc.warn_low_cell_voltage': 'Napięcie ogniwa jest zbyt niskie',
    'warningDesc.warn_high_cell_voltage': 'Napięcie ogniwa jest zbyt wysokie',
    'warningDesc.protect_high_discharge_current': 'Prąd rozładowania jest zbyt wysoki, ochrona aktywowana',
    'warningDesc.protect_high_charge_current': 'Prąd ładowania jest zbyt wysoki, ochrona aktywowana',
    'warningDesc.protect_short_circuit': 'Wykryto zwarcie, ochrona aktywowana',
    'warningDesc.protect_low_total_voltage': 'Napięcie całkowite jest zbyt niskie, ochrona aktywowana',
    'warningDesc.protect_high_total_voltage': 'Napięcie całkowite jest zbyt wysokie, ochrona aktywowana',
    'warningDesc.protect_low_cell_voltage': 'Napięcie ogniwa jest zbyt niskie, ochrona aktywowana',
    'warningDesc.protect_high_cell_voltage': 'Napięcie ogniwa jest zbyt wysokie, ochrona aktywowana',
    'warningDesc.protect_low_env_temp': 'Temperatura otoczenia jest zbyt niska, ochrona aktywowana',
    'warningDesc.protect_high_env_temp': 'Temperatura otoczenia jest zbyt wysoka, ochrona aktywowana',
    'warningDesc.protect_high_mos_temp': 'Temperatura MOS jest zbyt wysoka, ochrona aktywowana',
    'warningDesc.protect_low_discharge_temp': 'Temperatura rozładowania jest zbyt niska, ochrona aktywowana',
    'warningDesc.protect_low_charge_temp': 'Temperatura ładowania jest zbyt niska, ochrona aktywowana',
    'warningDesc.protect_high_discharge_temp': 'Temperatura rozładowania jest zbyt wysoka, ochrona aktywowana',
    'warningDesc.protect_high_charge_temp': 'Temperatura ładowania jest zbyt wysoka, ochrona aktywowana',
    'warningDesc.fault_sampling': 'Obwód próbkowania baterii jest nieprawidłowy, proszę sprawdzić sprzęt',
    'warningDesc.fault_cell': 'Usterka ogniwa baterii, proszę sprawdzić pakiet baterii',
    'warningDesc.fault_ntc': 'Usterka czujnika temperatury, niemożliwe jest dokładne pomiarowanie temperatury',
    'warningDesc.fault_discharge_mos': 'Usterka MOS rozładowania, niemożliwe jest normalne rozładowanie',
    'warningDesc.fault_charge_mos': 'Usterka MOS ładowania, niemożliwe jest normalne ładowanie',
    'warningDesc.fault_adapter_temp': 'Temperatura płyty adaptera jest zbyt wysoka',
    'warningDesc.fault_virtual_connection': 'Kontakt baterii jest słaby, proszę sprawdzić połączenie',

    // Charging status constants

    // Authentication
    'auth.loginTitle': 'Zaloguj się',
    'auth.registerTitle': 'Utwórz konto',
    'auth.forgotPassword': 'Zapomniałeś hasła?',
    'auth.noAccount': 'Nie masz konta?',
    'auth.haveAccount': 'Masz już konto?',
    'auth.loginSuccess': 'Zalogowano pomyślnie',
    'auth.registerSuccess': 'Rejestracja udana',
    'auth.registerFailed': 'Rejestracja nieudana',
    'auth.logoutSuccess': 'Wylogowano pomyślnie',
    'auth.invalidCredentials': 'Nieprawidłowy email lub hasło',
    'auth.passwordMismatch': 'Hasła nie pasują',
    'auth.emailExists': 'Email już istnieje',
    'auth.usernameExists': 'Nazwa użytkownika zajęta',
    'auth.managerEmail': 'Email admina (opcjonalnie)',
    'auth.managerEmailHelp': 'Jeśli znasz email admina, wpisz go tutaj',
    'auth.invitationCode': 'Kod zaproszenia (opcjonalnie)',
    'auth.invitationCodeHelp': 'Jeśli masz kod zaproszenia, wpisz go tutaj',
    'auth.forgotPasswordDesc': 'Wprowadź zarejestrowany adres email, a wyślemy Ci link do resetowania hasła.',
    'auth.forgotPasswordSuccess': 'Email wysłany. Sprawdź skrzynkę.',
    'auth.invalidToken': 'Nieprawidłowy Token',
    'auth.tokenErrorDesc': 'Nieprawidłowy lub brakujący token resetowania. Uzyskaj dostęp z linku w emailu.',
    'auth.passwordUpdated': 'Hasło zresetowane. Przekierowanie...',
    'auth.resetPasswordTitle': 'Resetuj Hasło',

    // Settings
    'settings.about': 'O Aplikacji',
    'settings.aboutDesc': 'Home Battery IoT to system monitorowania domowych baterii.',
    'settings.languageUpdated': 'Język zaktualizowany',
    'settings.updateFailed': 'Nie udało się zaktualizować ustawień',
    'settings.changePassword': 'Zmień Hasło',
    'settings.currentPassword': 'Aktualne Hasło',
    'settings.newPassword': 'Nowe Hasło',
    'settings.confirmPassword': 'Potwierdź Nowe Hasło',
    'settings.passwordUpdated': 'Hasło zmienione pomyślnie',
    'settings.passwordMismatch': 'Hasła nie pasują',
    'settings.passwordTooShort': 'Hasło min. 6 znaków',
    'settings.usernameUpdated': 'Nazwa użytkownika zaktualizowana',
    'settings.appearance': 'Ustawienia Wyglądu',
    'settings.avatar': 'Awatar',
    'settings.changeAvatar': 'Zmień Awatar',
    'settings.avatarHint': 'Max 2MB, JPG/PNG/GIF/WebP',
    'settings.avatarUpdated': 'Awatar zaktualizowany',
    'settings.invalidFileType': 'Wybierz plik obrazu',
    'settings.fileTooLarge': 'Plik za duży (max 2MB)',
    'settings.timezone': 'Strefa Czasowa',
    'settings.timezoneUpdated': 'Strefa czasowa zaktualizowana',

    // Timezone labels
    'timezones.UTC': 'UTC (Czas Uniwersalny)',
    'timezones.Europe/London': 'Londyn (GMT/BST)',
    'timezones.Europe/Dublin': 'Dublin (GMT/IST)',
    'timezones.Europe/Paris': 'Paryż (CET/CEST)',
    'timezones.Europe/Berlin': 'Berlin (CET/CEST)',
    'timezones.Europe/Amsterdam': 'Amsterdam (CET/CEST)',
    'timezones.Europe/Brussels': 'Bruksela (CET/CEST)',
    'timezones.Europe/Rome': 'Rzym (CET/CEST)',
    'timezones.Europe/Madrid': 'Madryt (CET/CEST)',
    'timezones.Europe/Lisbon': 'Lizbona (WET/WEST)',
    'timezones.Europe/Vienna': 'Wiedeń (CET/CEST)',
    'timezones.Europe/Zurich': 'Zurych (CET/CEST)',
    'timezones.Europe/Stockholm': 'Sztokholm (CET/CEST)',
    'timezones.Europe/Oslo': 'Oslo (CET/CEST)',
    'timezones.Europe/Copenhagen': 'Kopenhaga (CET/CEST)',
    'timezones.Europe/Helsinki': 'Helsinki (EET/EEST)',
    'timezones.Europe/Warsaw': 'Warszawa (CET/CEST)',
    'timezones.Europe/Prague': 'Praga (CET/CEST)',
    'timezones.Europe/Athens': 'Ateny (EET/EEST)',
    'timezones.Europe/Istanbul': 'Stambuł (TRT)',
    'timezones.Europe/Moscow': 'Moskwa (MSK)',
    'timezones.America/New_York': 'Nowy Jork (EST/EDT)',
    'timezones.America/Toronto': 'Toronto (EST/EDT)',
    'timezones.America/Chicago': 'Chicago (CST/CDT)',
    'timezones.America/Denver': 'Denver (MST/MDT)',
    'timezones.America/Phoenix': 'Phoenix (MST)',
    'timezones.America/Los_Angeles': 'Los Angeles (PST/PDT)',
    'timezones.America/Vancouver': 'Vancouver (PST/PDT)',
    'timezones.America/Anchorage': 'Anchorage (AKST/AKDT)',
    'timezones.Pacific/Honolulu': 'Honolulu (HST)',
    'timezones.America/Mexico_City': 'Meksyk (CST/CDT)',
    'timezones.America/Bogota': 'Bogota (COT)',
    'timezones.America/Lima': 'Lima (PET)',
    'timezones.America/Santiago': 'Santiago (CLT/CLST)',
    'timezones.America/Sao_Paulo': 'Sao Paulo (BRT)',
    'timezones.America/Buenos_Aires': 'Buenos Aires (ART)',
    // Middle East
    'timezones.Asia/Jerusalem': 'Jerozolima (IST)',
    'timezones.Asia/Beirut': 'Bejrut (EET/EEST)',
    'timezones.Asia/Amman': 'Amman (EET/EEST)',
    'timezones.Asia/Baghdad': 'Bagdad (AST)',
    'timezones.Asia/Kuwait': 'Kuwejt (AST)',
    'timezones.Asia/Dubai': 'Dubaj (GST)',
    'timezones.Asia/Muscat': 'Muskat (GST)',
    'timezones.Asia/Riyadh': 'Rijad (AST)',
    'timezones.Asia/Qatar': 'Doha (AST)',
    'timezones.Asia/Bahrain': 'Bahrajn (AST)',
    'timezones.Asia/Tehran': 'Teheran (IRST)',
    // Central Asia
    'timezones.Asia/Kabul': 'Kabul (AFT)',
    'timezones.Asia/Karachi': 'Karaczi (PKT)',
    'timezones.Asia/Tashkent': 'Taszkent (UZT)',
    'timezones.Asia/Almaty': 'Ałmaty (ALMT)',
    // South Asia
    'timezones.Asia/Kolkata': 'Mumbaj / Delhi (IST)',
    'timezones.Asia/Colombo': 'Kolombo (IST)',
    'timezones.Asia/Kathmandu': 'Katmandu (NPT)',
    'timezones.Asia/Dhaka': 'Dhaka (BST)',
    'timezones.Asia/Yangon': 'Rangun (MMT)',
    // Southeast Asia
    'timezones.Asia/Bangkok': 'Bangkok (ICT)',
    'timezones.Asia/Ho_Chi_Minh': 'Ho Chi Minh (ICT)',
    'timezones.Asia/Jakarta': 'Dżakarta (WIB)',
    'timezones.Asia/Singapore': 'Singapur (SGT)',
    'timezones.Asia/Kuala_Lumpur': 'Kuala Lumpur (MYT)',
    'timezones.Asia/Manila': 'Manila (PHT)',
    // East Asia
    'timezones.Asia/Hong_Kong': 'Hongkong (HKT)',
    'timezones.Asia/Shanghai': 'Szanghaj / Pekin (CST)',
    'timezones.Asia/Taipei': 'Tajpej (CST)',
    'timezones.Asia/Seoul': 'Seul (KST)',
    'timezones.Asia/Tokyo': 'Tokio (JST)',
    // Oceania
    'timezones.Australia/Perth': 'Perth (AWST)',
    'timezones.Australia/Adelaide': 'Adelajda (ACST/ACDT)',
    'timezones.Australia/Brisbane': 'Brisbane (AEST)',
    'timezones.Australia/Sydney': 'Sydney (AEST/AEDT)',
    'timezones.Australia/Melbourne': 'Melbourne (AEST/AEDT)',
    'timezones.Pacific/Auckland': 'Auckland (NZST/NZDT)',
    // Africa (North)
    'timezones.Africa/Casablanca': 'Casablanca (WET/WEST)',
    'timezones.Africa/Algiers': 'Algier (CET)',
    'timezones.Africa/Tunis': 'Tunis (CET)',
    'timezones.Africa/Tripoli': 'Trypolis (EET)',
    'timezones.Africa/Cairo': 'Kair (EET)',
    // Africa (East)
    'timezones.Africa/Khartoum': 'Chartum (CAT)',
    'timezones.Africa/Addis_Ababa': 'Addis Abeba (EAT)',
    'timezones.Africa/Nairobi': 'Nairobi (EAT)',
    // Africa (West)
    'timezones.Africa/Lagos': 'Lagos (WAT)',
    'timezones.Africa/Accra': 'Akra (GMT)',
    // Africa (South)
    'timezones.Africa/Johannesburg': 'Johannesburg (SAST)',
    'timezones.Africa/Cape_Town': 'Kapsztad (SAST)',

    'common.uploading': 'Wysyłanie...',

    // Errors
    'error.pageNotFound': 'Strona Nie Znaleziona',
    'error.pageNotFoundDesc': 'Strona, której szukasz, mogła zostać usunięta, zmieniona nazwa lub jest tymczasowo niedostępna.',
    'error.fetchFailed': 'Błąd pobierania danych',
    'error.createFailed': 'Błąd tworzenia',
    'error.copyFailed': 'Błąd kopiowania',
    'error.processFailed': 'Błąd przetwarzania',

    // Admin
    'admin.dashboard': 'Panel Admina',
    'admin.superDashboard': 'Panel Superadmina',
    'admin.managedUsers': 'Zarządzani Użytk.',
    'admin.managedDevices': 'Zarządzane Urządz.',
    'admin.role': 'Rola',
    'admin.superadmin': 'Superadmin',
    'admin.noUsers': 'Brak użytkowników',
    'admin.userList': 'Lista Użytk.',
    'admin.adminList': 'Lista Adminów',
    'admin.deviceList': 'Lista Urządzeń',
    'admin.noAdmins': 'Brak adminów',
    'admin.addAdmin': 'Dodaj Admina',
    'admin.createError': 'Błąd tworzenia admina',
    'admin.fillAllFields': 'Wypełnij wszystkie pola',
    'admin.deviceCount': 'Liczba Urządzeń',
    'admin.assignManager': 'Przypisz Admina',
    'admin.selectManager': 'Wybierz Admina',
    'admin.noManager': 'Brak Admina (usuń)',
    'admin.assigningUser': 'Przypisywanie',
    'admin.assign': 'Przypisz',
    'admin.assignError': 'Błąd przypisywania',
    'admin.self': 'Własne',
    'admin.active': 'Aktywny',
    'admin.used': 'Użyty',
    'admin.adminPanel': 'Panel Admina',
    'admin.newsManagement': 'Zarządz. Newsami',
    'admin.addNews': 'Dodaj News',
    'admin.editNews': 'Edytuj News',
    'admin.deleteNews': 'Usuń News',
    'admin.deleteNewsConfirm': 'Usunąć ten artykuł?',
    'admin.newsTitle': 'Tytuł',
    'admin.newsSummary': 'Streszczenie',
    'admin.newsContent': 'Treść',
    'admin.newsImageUrl': 'URL Obrazu',
    'admin.newsPublished': 'Opublikowany',
    'admin.newsDraft': 'Wersja Robocza',
    'admin.newsStatus': 'Status',
    'admin.newsCreateSuccess': 'News utworzony',
    'admin.newsUpdateSuccess': 'News zaktualizowany',
    'admin.newsDeleteSuccess': 'News usunięty',

    // Invitation code management
    'admin.invitationManagement': 'Zarządz. Kodami Zaproszeń',
    'admin.createInvitation': 'Utwórz Zaproszenie',
    'admin.invitationCode': 'Kod Zaproszenia',
    'admin.invitationCreated': 'Zaproszenie utworzone',
    'admin.copy': 'Kopiuj',
    'admin.codeCopied': 'Skopiowano do schowka',
    'admin.noInvitations': 'Brak zaproszeń',

    // Authorization request related
    'user.authRequests': 'Prośby o Autoryzację',
    'user.authRequestManagement': 'Zarządz. Prośbami',
    'user.createAuthRequest': 'Utwórz Prośbę',
    'user.authCode': 'Kod Autoryzacji',
    'user.authRequestCreated': 'Prośba utworzona',
    'user.shareAuthLink': 'Udostępnij Link',
    'user.shareAuthLinkHelp': 'Wyślij ten link do admina, aby autoryzował zarządzanie Twoim kontem',
    'user.linkCopied': 'Skopiowano do schowka',
    'user.copyLink': 'Kopiuj Link',
    'user.share': 'Udostępnij',
    'user.shareLink': 'Udostępnij Link',
    'user.authRequestHelp': 'Utwórz prośbę o autoryzację, aby pozwolić adminowi zarządzać Twoim kontem',
    'user.authRequestShareTitle': 'Autoryzacja Baterii IoT',
    'user.authRequestShareText': 'Proszę o autoryzację jako mój admin systemu baterii',
    'common.noAuthRequests': 'Brak próśb o autoryzację',
    'user.pending': 'Oczekująca',
    'user.accepted': 'Zaakceptowana',
    'user.rejected': 'Odrzucona',

    'admin.authRequestReview': 'Przegląd Prośby',
    'admin.authRequestDetails': 'Szczegóły Prośby',
    'admin.authRequestLoadError': 'Błąd ładowania próśb',
    'admin.requestCode': 'Kod Prośby',
    'admin.createdBy': 'Utworzona Przez',
    'admin.processedBy': 'Przetworzona Przez',
    'admin.processedAt': 'Przetworzona O',
    'admin.unknownUser': 'Nieznany Użytkownik',
    'admin.accept': 'Akceptuj',
    'admin.reject': 'Odrzuć',
    'admin.authRequestAccepted': 'Prośba zaakceptowana',
    'admin.authRequestRejected': 'Prośba odrzucona',
    'admin.authRequestNotForAdmin': 'Zarządzanie prośbami o autoryzację dotyczy tylko zwykłych użytkowników. Jako admin możesz przeglądać i przetwarzać prośby od użytkowników.',

    // Battery pack details
    'battery.packageDetails': 'Szczegóły Pakietu',

    'battery.basicInfo': 'Podstawowe Informacje',
    'battery.cellCount': 'Liczba Ogniw',
    'battery.tempSensorCount': 'Liczba Czujników Temp.',
    'battery.chargeCurrentStatus': 'Status Prądu Ładowania',
    'battery.totalVoltageStatus': 'Status Napięcia Całk.',
    'battery.dischargeCurrentStatus': 'Status Prądu Rozładow.',
    'battery.controlStatus': 'Status Sterowania',
    'battery.instructionState': 'Stan Instrukcji',
    'battery.controlState': 'Stan Sterowania',
    'battery.chargerAvailable': 'Ładowarka Dostępna',
    'battery.warningStatus': 'Status Ostrzeżeń',
    'battery.led_warning': 'Ostrzeżenie LED',
    'battery.buzzer_warning': 'Ostrzeżenie Brzęczyka',
    'battery.freq_shift': 'Przesunięcie Częst.',
    'battery.parallelStatus': 'Status Równoległego Systemu',
    'battery.parallelCount': 'Liczba Baterii Równoległych',
    'battery.avgCycleCount': 'Średnia Liczba Cykli',
    'battery.cycleCountUnit': 'cykli',


    'battery.standby': 'Czuwanie',
    'battery.cellVoltage': 'Napięcie Ogniwa',
    'battery.batteryPackUnavailable': 'Dane pakietu tymczasowo niedostępne, próbuję wyświetlić ostatnie dane...',
    'battery.normalStatus': 'Ten pakiet baterii jest normalny, brak ostrzeżeń lub usterek',
    'battery.warn_high_charge_temp': 'Wysoka Temp. Ładowania',

    // Dashboard new content
    'dashboard.soc': 'SOC',
    'dashboard.voltage': 'Napięcie Całk.',
    'dashboard.current': 'Prąd Całk.',
    'dashboard.temperature': 'Najw. Temperatura',
    'dashboard.systemStatus': 'Status Systemu',
    'dashboard.totalDevices': 'Urządzenia Razem',
    'dashboard.onlineDevices': 'Urządzenia Online',
    'dashboard.deviceStatus': 'Status Urządzenia',
    'dashboard.batteryStatus': 'Status Baterii',
    'dashboard.powerStatus': 'Status Mocy',
    'dashboard.temperatureStatus': 'Status Temperatury',
    'dashboard.avgSOC': 'Średni SOC',
    'dashboard.types': 'Typy',
    'dashboard.batteryHistory': 'Historia Baterii',
    'dashboard.voltageHistory': 'Historia Napięcia',
    'dashboard.currentHistory': 'Historia Prądu',
    'dashboard.socHistory': 'Historia SOC',
    'dashboard.temperatureHistory': 'Historia Temp.',
    'dashboard.lastHour': 'Ostatnia Godzina',
    'dashboard.last6Hours': 'Ostatnie 6 Godzin',
    'dashboard.lastDay': 'Ostatnie 24 Godziny',
    'dashboard.lastWeek': 'Ostatni Tydzień',
    'dashboard.lastMonth': 'Ostatni Miesiąc',
    'dashboard.batteryDetails': 'Szczegóły Baterii',
    'dashboard.deviceAnalysis': 'Analiza Urządzenia',
    'dashboard.systemOverview': 'Przegląd Systemu',
    'dashboard.deviceTypeDistribution': 'Dystrybucja Typów',
    'dashboard.voltageAndCurrentOverview': 'Przegląd Napięcia i Prądu',
    'dashboard.onlinePercentage': 'Procent Online',
    'dashboard.noAlerts': 'Brak alertów',

    // Dashboard page specific
    'dashboard.totalInstallations': 'Instalacje Razem',
    'dashboard.viewAllInstallations': 'Zobacz Wszystkie',
    'dashboard.activeInstallations': 'Aktywne Instalacje',
    'dashboard.allInstallations': 'Wszystkie Instalacje',
    'dashboard.systemAlertsNotices': 'Alerty i Powiadomienia',
    'dashboard.deviceOffline': 'Urządzenie Offline',
    'dashboard.deviceOfflineDesc': 'Urządzenie {{name}} ({{id}}) jest offline. Sprawdź połączenie.',
    'dashboard.deviceAlarm': 'Alarm Urządzenia',
    'dashboard.deviceAlarmDesc': 'Urządzenie {{name}} ({{id}}) ma aktywne alarmy. Sprawdź status.',
    'dashboard.systemNormal': 'System Normalny',
    'dashboard.systemNormalDesc': 'Wszystkie systemy działają normalnie.',
    'dashboard.latestNews': 'Aktualności Produktów',

    // InstallationList page
    'installations.loadError': 'Błąd ładowania instalacji. Spróbuj ponownie później.',
    'installations.noInstallations': 'Nie znaleziono instalacji.',
    'installations.realtime': 'Real-time',
    'installations.oldData': 'Stare Dane',
    'installations.batteries': 'Baterie',
    'installations.lastUpdate': 'Ostatnia Aktualizacja',
    'installations.deviceName': 'Nazwa Instalacji (opcjonalnie)',
    'installations.deviceNamePlaceholder': 'Mój System Baterii',
    'installations.deviceNameHelper': 'Nadaj urządzeniu przyjazną nazwę',
    'installations.deviceIdRequired': 'ID urządzenia jest wymagane',
    'installations.deviceIdPlaceholder': 'ID na etykiecie WIFI',
    'installations.deviceClaimed': 'Urządzenie dodane pomyślnie',
    'installations.addFailed': 'Błąd dodawania urządzenia',
    'installations.otherType': 'Inne',


    // Installation Detail page
    'detail.backToList': 'Wróć do Listy',
    'detail.installationDetail': 'Szczegóły Instalacji',
    'detail.installationName': 'Nazwa Instalacji',
    'detail.owner': 'Właściciel',
    'detail.batteryCount': 'Liczba Baterii',
    'detail.realtimeMetrics': 'Wskaźniki Real-time',
    'detail.avgSOC': 'Średni SOC',
    'detail.avgSOH': 'Średni SOH',
    'detail.maxCellVol': 'Maks. Napięcie Ogniw',
    'detail.minCellVol': 'Min. Napięcie Ogniw',
    'detail.cellVolDiff': 'Różnica Napięć',

    // Battery Detail page
    'battery.packDetail': 'Szczegóły Pakietu #{{index}}',

    'battery.packNotFound': 'Nie znaleziono danych pakietu',
    'battery.loadError': 'Błąd ładowania danych baterii',

    // Battery Overview
    'battery.packVoltage': 'Napięcie Pakietu',
    'battery.packCurrent': 'Prąd Pakietu',
    'battery.packPower': 'Moc Pakietu',
    'battery.chargerConnected': 'Ładowarka Podłączona',
    'battery.fullEnergy': 'Pełna Energia',
    'battery.remainEnergy': 'Energia Pozostała',

    'common.yes': 'Tak',
    'common.no': 'Nie',
    'common.on': 'Włączony',
    'common.off': 'Wyłączony',
    'common.ongoing': 'W Trakcie',


    // RealTime Monitor
    'battery.cellVoltages': 'Napięcia Ogniw',
    'battery.temperatures': 'Monitoring Temp.',

    // History Charts
    'battery.historyTrends': 'Trendy Historyczne',
    'battery.voltageCurrent': 'Napięcie i Prąd',

    'battery.dragToSelect': 'Przeciągnij, aby wybrać zakres czasu',

    'battery.alarmDetails': 'Szczegóły Alarmu',
    'battery.noActiveAlarms': 'Brak aktywnych alarmów',
    'battery.sensor': 'Czujnik',
    'battery.issue': 'Problem',
    'battery.tempSensorIssues': 'Problemy z Czujnikami Temp.',

    // Charts & Widgets
    'battery.minCellVoltage': 'Min. Napięcie Ogniw',
    'battery.maxCellVoltage': 'Maks. Napięcie Ogniw',


    'battery.mosTemp': 'Temperatura MOS',
    'battery.envTemp': 'Temperatura Otoczenia',
    'battery.otherTemps': 'Inne Temperatury',


    'battery.noDataAvailable': 'Brak dostępnych danych',
    'battery.fetchError': 'Błąd pobierania danych historycznych',
    'battery.generalError': 'Wystąpił błąd',

    // Settings - Common
    'settings.recover': 'Odzyskaj',
    'settings.delay': 'Opóźnienie',
    'settings.unitV': 'Jedn.: V',
    'settings.unitA': 'Jedn.: A',
    'settings.unitMs': 'Jedn.: ms',
    'settings.unitUs': 'Jedn.: μs',
    'settings.unitC': 'Jedn.: °C',
    'settings.charge': 'Ładowanie',
    'settings.discharge': 'Rozładowanie',
    'settings.high': 'Wysoka',
    'settings.low': 'Niska',
    'settings.description': 'Opis',
    'settings.read': 'Odczytaj',
    'settings.setting': 'Ustawianie...',
    'settings.readSuccess': 'Odczytano pomyślnie',
    'settings.timeout': 'Przekroczono czas',
    'settings.operationFailed': 'Operacja nieudana',
    'settings.failed': 'Niepowodzenie',
    'settings.jkReadOnlyNote': 'Ustawienia JK BMS są aktualizowane automatycznie przez transmisję i są tylko do odczytu w tym systemie.',
    'settings.lastUpdated': 'Ostatnia aktualizacja',
    'settings.chargeHighTemp': 'Wysoka temp. ładowania',
    'settings.dischargeHighTemp': 'Wysoka temp. rozładowania',
    'settings.designCapacity': 'Pojemność znamionowa',
    'settings.balanceMaxCurrent': 'Maks. prąd balansowania',
    'settings.balanceTriggerDiff': 'Różnica balansowania',

    // Settings - Control Tab
    'settings.mosControl': 'Sterowanie MOS',
    'settings.chargeMosControl': 'Sterowanie MOS Ładowania',
    'settings.openChargeMos': 'Otwórz MOS Ładowania',
    'settings.closeChargeMos': 'Zamknij MOS Ładowania',
    'settings.dischargeMosControl': 'Sterowanie MOS Rozładowania',
    'settings.openDischargeMos': 'Otwórz MOS Rozładowania',
    'settings.closeDischargeMos': 'Zamknij MOS Rozładowania',
    'settings.powerManagement': 'Zarządzanie Energią',
    'settings.shutdownSleep': 'Wyłącz/Uśpij',
    'settings.opening': 'Otwieranie...',
    'settings.closing': 'Zamykanie...',
    'settings.executing': 'Wykonywanie...',

    // Settings - Protection Tab
    'settings.protGroup1': 'Parametry Ochrony Napięcia',
    'settings.cellOvercharge': 'Przeładowanie Ogniwa',
    'settings.cellOverchargeDesc': 'Gdy napięcie ogniwa ciągle przekracza wartość ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania. Po wyzwoleniu ochrony, gdy wszystkie napięcia ogniw spadną poniżej wartości odzysku, system przywraca funkcję ładowania.',
    'settings.cellOverdischarge': 'Rozładowanie Ogniwa',
    'settings.cellOverdischargeDesc': 'Gdy napięcie ogniwa ciągle spada poniżej wartości ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie rozładowania. Po wyzwoleniu ochrony, gdy wszystkie napięcia ogniw wzrosną powyżej wartości odzysku, system przywraca funkcję rozładowania.',
    'settings.totalOvercharge': 'Przeładowanie Całkowite',
    'settings.totalOverchargeDesc': 'Gdy napięcie całkowite ciągle przekracza wartość ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania. Po wyzwoleniu ochrony, gdy wszystkie napięcia ogniw spadną poniżej wartości odzysku, system przywraca funkcję ładowania.',
    'settings.totalOverdischarge': 'Rozładowanie Całkowite',
    'settings.totalOverdischargeDesc': 'Gdy napięcie całkowite ciągle spada poniżej wartości ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie rozładowania. Po wyzwoleniu ochrony, gdy wszystkie napięcia ogniw wzrosną powyżej wartości odzysku, system przywraca funkcję rozładowania.',

    'settings.protGroup2': 'Parametry Ochrony Prądu',
    'settings.chargeOvercurrent': 'Przeciążenie Ładowania',
    'settings.chargeOvercurrentDesc': 'Wartość ostrzegawcza to maksymalny prąd ładowania żądany od falownika. Gdy prąd ładowania ciągle przekracza wartość ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania.',
    'settings.dischargeOvercurrent1': 'Przeciążenie Rozładowania 1',
    'settings.dischargeOvercurrent1Desc': 'Wartość ostrzegawcza to maksymalny prąd rozładowania żądany od falownika. Gdy prąd rozładowania ciągle przekracza wartość ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie rozładowania.',
    'settings.dischargeOvercurrent2': 'Przeciążenie Rozładowania 2',
    'settings.dischargeOvercurrent2Desc': 'Gdy prąd rozładowania ciągle przekracza wartość ochrony przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie rozładowania.',
    'settings.maxChargeCurrent': 'Limit Prądu Ładowania',
    'settings.maxChargeCurrentDesc': 'Limit Prądu Ładowania (CCL) to maksymalny dopuszczalny prąd ładowania, który pojedynczy moduł baterii zgłasza falownikowi w normalnych warunkach pracy. Gdy N modułów baterii jest połączonych równolegle, całkowity maksymalny prąd ładowania żądany przez system baterii od falownika to suma poszczególnych CCL, tj. CCL × N. \nWartość ochrony to próg prądu, przy którym pojedynczy moduł baterii wyzwala ochronę przeciążeniową. CCL musi być ustawiony niżej niż wartość ochrony.',
    'settings.maxDischargeCurrent': 'Limit Prądu Rozładowania',
    'settings.maxDischargeCurrentDesc': 'Limit Prądu Rozładowania (DCL) to maksymalny dopuszczalny prąd rozładowania, który pojedynczy moduł baterii zgłasza falownikowi w normalnych warunkach pracy. Gdy N modułów baterii jest połączonych równolegle, całkowity maksymalny prąd rozładowania żądany przez system baterii od falownika to suma poszczególnych DCL, tj. DCL × N. \nWartość ochrony to próg prądu, przy którym pojedynczy moduł baterii wyzwala ochronę przeciążeniową. DCL musi być ustawiony niżej niż wartość ochrony.',
    'settings.maxChargeVoltage': 'Limit Napięcia Ładowania',
    'settings.maxChargeVoltageDesc': 'Limit Napięcia Ładowania (CVL) to maksymalne całkowite napięcie żądane przez system baterii od falownika.',
    'settings.chargeVoltageLimitV': 'CVL (V)',
    'settings.chargeCurrentLimitA': 'CCL (A)',
    'settings.dischargeCurrentLimitA': 'DCL (A)',
    'settings.shortCircuitDesc': 'Gdy zwarcie zostanie wykryte przez ustawione opóźnienie, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania i rozładowania.',

    'settings.protGroup3': 'Parametry Ochrony Temperatury',
    'settings.tempHigh': 'Ochrona Wysokiej Temp.',
    'settings.tempHighDesc': 'Gdy temperatura przekroczy wartość ochrony, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania lub rozładowania. Po wyzwoleniu ochrony, gdy temperatura spadnie poniżej wartości odzysku, system przywraca funkcję ładowania lub rozładowania.',
    'settings.tempLow': 'Ochrona Niskiej Temp.',
    'settings.tempLowDesc': 'Gdy temperatura spadnie poniżej wartości ochrony, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania lub rozładowania. Po wyzwoleniu ochrony, gdy temperatura wzrośnie powyżej wartości odzysku, system przywraca funkcję ładowania lub rozładowania. Gdy temperatura spadnie poniżej wartości ostrzegawczej ładowania, funkcja grzania włącza się automatycznie. Gdy temperatura wzrośnie do wartości odzysku ładowania, funkcja grzania wyłącza się automatycznie.',
    'settings.mosTempHigh': 'Ochrona Wysokiej Temp. MOS',
    'settings.mosTempHighDesc': 'Gdy temperatura MOS jest wyższa niż wartość ochrony, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania i rozładowania. Po wyzwoleniu ochrony, gdy temperatura MOS spadnie poniżej wartości odzysku, system przywraca funkcję ładowania lub rozładowania.',
    'settings.envTemp': 'Ochrona Temp. Otoczenia',
    'settings.envTempDesc': 'Gdy temperatura otoczenia przekroczy wartość ochrony wysokiej temperatury lub spadnie poniżej wartości ochrony niskiej temperatury, BMS natychmiast wykona działanie ochronne i wymusi zatrzymanie ładowania lub rozładowania. Po wyzwoleniu ochrony, gdy temperatura otoczenia powróci do odpowiedniego zakresu temperatury odzysku, system automatycznie przywróci funkcję ładowania lub rozładowania.',

    'settings.enableProtection': 'Włącz Ochronę',
    'settings.chargeTempProt': 'Ochrona Temp. Ładowania',
    'settings.dischargeTempProt': 'Ochrona Temp. Rozładowania',

    // Settings - History Tab
    'settings.historyManagement': 'Zarządz. Historią',
    'settings.reading': 'Odczytywanie...',
    'settings.readHistory': 'Odczytaj wszystkie rekordy (1-40)',
    'settings.stopReading': 'Zatrzymaj Odczyt',
    'settings.clearHistory': 'Wyczyść Historię',
    'settings.messages.historyReadComplete': 'Odczyt historii zakończony! Razem {{count}} rekordów',
    'settings.historyRecords': 'Rekordy Historii ({{count}})',
    'settings.record': 'Rekord {{index}}',
    'settings.timeUnknown': 'Nieznany Czas',
    'settings.cellInfo': 'Informacje o Ogniwach ({{count}})',
    'settings.tempSensors': 'Czujniki Temperatury ({{count}})',
    'settings.statusInfo': 'Informacje o Statusie',
    'settings.noHistoryFound': 'Nie znaleziono rekordów historii',
    'settings.clearHistoryResult': 'Wynik czyszczenia historii',
    'settings.confirmClearHistory': 'Potwierdź Wyczyszczenie',
    'settings.confirmClearHistoryDesc': 'Czy na pewno chcesz usunąć wszystkie rekordy historii z BMS?',
    'settings.clearHistoryWarning': 'Ta operacja trwale usunie wszystkie dane historii z urządzenia BMS i nie może zostać odzyskana.',
    'settings.confirmDelete': 'Potwierdź Usunięcie',

    // Settings - Protocol Tab
    'settings.inverterProtocolConfig': 'Konfiguracja Protokołu Falownika',
    'settings.protocolSelectDesc': 'Po odczytaniu listy protokołów falownika, wybierz używany protokół z listy rozwijanej.',



    'settings.canProtocol': 'Protokół CAN',
    'settings.rs485Protocol': 'Protokół RS485',
    'settings.selectCanProtocol': 'Wybierz Protokół CAN',
    'settings.selectRs485Protocol': 'Wybierz Protokół RS485',

    // Settings - System Tab
    'settings.mainBatterySettings': 'Ustawienia Głównego Pakietu',
    'settings.systemConfig': 'Konfiguracja Baterii',
    'settings.otherConfig': 'Inne Ustawienia',
    'settings.timeSettings': 'Ustawienia Czasu',
    'settings.timeSettingsDesc': 'Wewnętrzny czas BMS, używany do wyświetlania i rejestrowania danych. Synchronizacja z czasem lokalnym ułatwia śledzenie danych.',
    'settings.syncTime': 'Synchronizuj Czas Lokalny',
    'settings.bmsTime': 'Czas BMS',
    'settings.capacitySettings': 'Ustawienia Pojemności',
    'settings.capacitySettingsDesc': 'Modyfikacja ustawienia pozostałej pojemności wpływa na wyświetlanie procentowe SOC. Pojemność nominalna to pojemność baterii w fabryce, a pojemność pełnego naładowania wskazuje aktualną rzeczywistą pojemność baterii, która zmniejsza się wraz z czasem użytkowania i liczbą cykli.',
    'settings.batterySeries': 'Ustawienia Liczby Ogniw',
    'settings.batterySeriesDesc': 'Domyślna liczba ogniw w szeregu w systemie to 16. Gdy rzeczywista liczba ogniw w szeregu jest mniejsza niż 16, dostosuj ją tutaj do odpowiedniej wartości rzeczywistej.',
    'settings.batterySeriesHelper': 'Liczba ogniw w szeregu',
    'settings.cycleCount': 'Ustawienia Liczby Cykli',
    'settings.cycleCountDesc': 'Liczba cykli automatycznie akumuluje się podczas procesu ładowania/rozładowania baterii i obsługuje ręczną regulację tutaj.',
    'settings.cycleCountHelper': 'Liczba cykli ładowania/rozładowania baterii',
    'settings.fullChargeParams': 'Parametry Pełnego Naładowania',
    'settings.fullChargeParamsDesc': 'Ustaw warunki określania pełnego naładowania. Gdy napięcie i prąd baterii jednocześnie spełniają warunki odcięcia, BMS określa, że bateria jest w pełni naładowana. Alarm niskiej pojemności służy do ustawienia progu ostrzegawczego przy niskim SOC.',
    'settings.fullChargeCutoffVoltage': 'Napięcie Odcięcia Pełnego Naładowania (V)',
    'settings.fullChargeCutoffCurrent': 'Prąd Odcięcia Pełnego Naładowania (A)',
    'settings.lowCapacityAlarm': 'Alarm Niskiej Pojemności (%)',
    'settings.capacityRelease': 'Ustawienia Uwolnienia Pojemności',
    'settings.capacityReleaseDesc': 'Ustaw Komendę (Set): A5\nUstaw próg SOC dla uwolnienia pojemności.',
    'settings.socValue': 'Wartość SOC (%)',
    'settings.socRange': 'Zakres: 74-97',
    'settings.currentZero': 'Kalibracja Zera Prądu',
    'settings.currentZeroDesc': 'Komenda: AA\nSkalibruj punkt zerowy czujnika prądu, gdy nie ma prądu. Można wprowadzić wartość korekty (domyślnie 0).',
    'settings.correctionValue': 'Wartość Korekty (0.1A)',
    'settings.refVoltage': 'Kalibracja Napięcia Odniesienia',
    'settings.refVoltageDesc': 'Komenda: A9\nSkalibruj napięcie odniesienia pakietu baterii (zazwyczaj odnosi się do napięcia próbkowania ogniwa). Wprowadź zmierzoną rzeczywistą wartość napięcia (mV).',
    'settings.actualVoltageMv': 'Rzeczywiste Napięcie (mV)',
    'settings.totalVoltage': 'Kalibracja Napięcia Całkowitego',
    'settings.totalVoltageDesc': 'Wprowadź tutaj rzeczywiste napięcie baterii zmierzone multimetrem lub innym sprzętem pomiarowym, które może być użyte do kalibracji wartości napięcia wyświetlanej przez BMS.',
    'settings.actualTotalVoltageMv': 'Rzeczywiste Napięcie Całk. (mV)',
    'settings.chargeCurrent': 'Kalibracja Prądu Ładowania',
    'settings.chargeCurrentDesc': 'Komenda: AC\nSkalibruj prąd ładowania. Wprowadź rzeczywistą zmierzoną wartość prądu ładowania (A). System automatycznie przeliczy na jednostkę 0.1A.',
    'settings.actualCurrentA': 'Rzeczywisty Prąd (A)',
    'settings.dischargeCurrent': 'Kalibracja Prądu Rozładowania',
    'settings.dischargeCurrentDesc': 'Komenda: AB\nSkalibruj prąd rozładowania. Wprowadź rzeczywistą zmierzoną wartość prądu rozładowania (A). System automatycznie przeliczy na jednostkę 0.1A.',
    'settings.systemInfo': 'Informacje o Systemie',
    'settings.versionInfo': 'Informacje o Wersji',
    'settings.versionInfoDesc': 'Wersja firmware BMS.',
    'settings.internalVersion': 'Wersja Firmware',
    'settings.internalVersionHelper': 'Informacje o wersji wewnętrznej',
    'settings.restoreDefault': 'Przywróć Domyślne',
    'settings.restoreDefaultDesc': 'Ta operacja przywróci wszystkie parametry do wartości fabrycznych BMS.',
    'settings.restoreDefaultBtn': 'Przywróć Domyślne',
    'settings.restoring': 'Przywracanie...',

    // Settings - Permissions Tab
    'settings.permissionsDesc': 'Udziel innym użytkownikom uprawnień do przeglądania lub sterowania tą instalacją.',
    'settings.shareSuccess': 'Udostępniono {{email}}',
    'settings.shareFailed': 'Błąd udostępniania',
    'settings.removeAccessSuccess': 'Uprawnienia usunięte',
    'settings.removeAccessFailed': 'Błąd usuwania uprawnień',
    'settings.loadingUsers': 'Ładowanie użytkowników...',
    'settings.noSharedUsers': 'Jeszcze nikomu nie udzielono dostępu.',
    'settings.noPermission': 'Nie masz uprawnień do zarządzania tą instalacją. Tylko właściciel może udostępniać instalację.',
    'settings.userEmail': 'Email Użytkownika',
    'settings.accessLevel': 'Poziom Dostępu',
    'settings.readOnly': 'Tylko Odczyt',
    'settings.readWrite': 'Odczyt i Zapis',
    'settings.sharing': 'Udostępnianie...',
    'settings.shareDevice': 'Udostępnij Instalację',
    'settings.usersWithAccess': 'Użytkownicy z Dostępem',
    'settings.remove': 'Usuń',

    // Settings - SettingsLogTab
    'settings.modificationLog': 'Dziennik Zmian Ustawień',
    'settings.loadHistoryFailed': 'Błąd ładowania historii',
    'settings.noChangesFound': 'Nie znaleziono zmian',
    'settings.logSetting': 'Element Ustawienia',
    'settings.na': 'N/D',

    // Settings - Params Mapping (Log Types)
    'settings.enabled': 'Włączone',
    'settings.controlMode': 'Tryb Sterowania',
    'settings.delayMs': 'Opóźnienie (ms)',
    'settings.unknown': 'Nieznane',
    'settings.alarmVoltage': 'Alarm (mV)',
    'settings.chargeAlarmVoltage': 'Alarm Ładowania (mV)',
    'settings.dischargeAlarmVoltage': 'Alarm Rozładowania (mV)',
    'settings.protectionVoltage': 'Ochrona (mV)',
    'settings.recoveryVoltage': 'Odzysk (mV)',
    'settings.alarmVoltageV': 'Alarm (V)',
    'settings.protectionVoltageV': 'Ochrona (V)',
    'settings.recoveryVoltageV': 'Odzysk (V)',
    'settings.alarmCurrentA': 'Alarm (A)',
    'settings.protectionCurrentA': 'Ochrona (A)',
    'settings.recoveryCurrentA': 'Odzysk (A)',
    'settings.chargeProtectionCurrentA': 'Ochrona Ładowania (A)',
    'settings.delayUs': 'Opóźnienie (μs)',
    'settings.alarmCurrentMa': 'Alarm (mA)',
    'settings.protectionCurrentMa': 'Ochrona (mA)',
    'settings.recoveryCurrentMa': 'Odzysk (mA)',
    'settings.alarmTemp': 'Alarm (°C)',
    'settings.protectionTemp': 'Ochrona (°C)',
    'settings.recoveryTemp': 'Odzysk (°C)',
    'settings.chargeHighTempAlarm': 'Alarm Wysokiej Temp. Ładowania (°C)',
    'settings.chargeHighTempProtection': 'Ochrona Wysokiej Temp. Ładowania (°C)',
    'settings.chargeHighTempRecovery': 'Odzysk Wysokiej Temp. Ładowania (°C)',
    'settings.dischargeHighTempAlarm': 'Alarm Wysokiej Temp. Rozładowania (°C)',
    'settings.dischargeHighTempProtection': 'Ochrona Wysokiej Temp. Rozładowania (°C)',
    'settings.dischargeHighTempRecovery': 'Odzysk Wysokiej Temp. Rozładowania (°C)',
    'settings.chargeLowTempAlarm': 'Alarm Niskiej Temp. Ładowania (°C)',
    'settings.chargeLowTempProtection': 'Ochrona Niskiej Temp. Ładowania (°C)',
    'settings.chargeLowTempRecovery': 'Odzysk Niskiej Temp. Ładowania (°C)',
    'settings.dischargeLowTempAlarm': 'Alarm Niskiej Temp. Rozładowania (°C)',
    'settings.dischargeLowTempProtection': 'Ochrona Niskiej Temp. Rozładowania (°C)',
    'settings.dischargeLowTempRecovery': 'Odzysk Niskiej Temp. Rozładowania (°C)',
    'settings.envHighTempAlarm': 'Alarm Wysokiej Temp. Otoczenia (°C)',
    'settings.envHighTempProtection': 'Ochrona Wysokiej Temp. Otoczenia (°C)',
    'settings.envHighTempRecovery': 'Odzysk Wysokiej Temp. Otoczenia (°C)',
    'settings.envLowTempAlarm': 'Alarm Niskiej Temp. Otoczenia (°C)',
    'settings.envLowTempProtection': 'Ochrona Niskiej Temp. Otoczenia (°C)',
    'settings.envLowTempRecovery': 'Odzysk Niskiej Temp. Otoczenia (°C)',
    'settings.socPercent': 'SOC (%)',
    'settings.sleepVoltageMv': 'Napięcie Uśpienia (mV)',
    'settings.sleepDelayMin': 'Opóźnienie Uśpienia (min)',
    'settings.chargeDelayMs': 'Opóźnienie Ładowania (ms)',
    'settings.chargeProtectionCurrentMa': 'Prąd Ochrony Ładowania (mA)',
    'settings.dischargeDelayMs': 'Opóźnienie Rozładowania (ms)',

    // Balance Settings
    'settings.balance': 'Ustawienia Aktywnego Balansowania',
    'settings.balanceDesc': 'Ustaw napięcie startu dla aktywnego balansowania. Aktywne balansowanie włącza się, gdy napięcie ogniwa jest większe niż napięcie startu, i wyłącza, gdy jest niższe.',
    'settings.balanceStartVoltage': 'Napięcie Startu',
    'settings.balanceStartDiff': 'Różnica Startu',
    'settings.balanceStartVoltageMv': 'Napięcie Startu (mV)',
    'settings.balanceStartDiffMv': 'Różnica Startu (mV)',

    // JK BMS Ustawienia - Ochrona napięcia pakietu
    'jk.noSettingsData': 'Brak danych ustawień. Ustawienia są aktualizowane gdy BMS nadaje ramkę SETUP.',
    'jk.chargeVoltages': 'Napięcia Ładowania',
    'jk.socSettings': 'Ustawienia SOC',
    'jk.packVoltageProtection': 'Ochrona napięcia pakietu',
    'jk.packOVP': 'Napięcie Ładowania Buforowego',
    'jk.packUVP': 'Maks. Napięcie Ładowania Falownika',
    'jk.floatVoltage': 'Napięcie Ładowania Buforowego',
    'jk.inverterMaxChargeVoltage': 'Maks. Napięcie Ładowania Falownika',
    'jk.soc100Voltage': 'Napięcie SOC 100%',
    'jk.soc0Voltage': 'Napięcie SOC 0%',
    'jk.smartSleepVoltage': 'Napięcie uśpienia',
    'jk.autoPowerOffVoltage': 'Napięcie auto. wyłączenia',
    // JK BMS Ustawienia - Ochrona prądowa
    'jk.currentProtection': 'Ochrona prądowa',
    'jk.chargeOC': 'Limit prądu ładowania',
    'jk.chargeOCPDelay': 'Opóźnienie OCP ład.',
    'jk.chargeOCPRelease': 'Zwolnienie OCP ład.',
    'jk.dischargeOC': 'Limit prądu rozładowania',
    'jk.dischargeOCPDelay': 'Opóźnienie OCP rozład.',
    'jk.dischargeOCPRelease': 'Zwolnienie OCP rozład.',
    'jk.scpRelease': 'Zwolnienie SCP',
    // JK BMS Ustawienia - Konfiguracja baterii
    'jk.batteryConfig': 'Konfiguracja baterii',
    'jk.cellCount': 'Liczba ogniw',
    'jk.chargeSwitch': 'Przełącznik ładowania',
    'jk.dischargeSwitch': 'Przełącznik rozładowania',
    'jk.balanceSwitch': 'Przełącznik balansowania',
    'jk.scpDelay': 'Opóźnienie SCP',
    // JK BMS Ustawienia - Konfiguracja urządzenia
    'jk.deviceConfig': 'Konfiguracja urządzenia',
    'jk.deviceAddress': 'Adres urządzenia',
    'jk.prechargeDelay': 'Opóźnienie wstępne',
    'jk.smartSleepTime': 'Czas uśpienia',
    'jk.heatEnabled': 'Ogrzewanie',
    'jk.tempSensorDisabled': 'Czujnik temp. wyłączony',
    'jk.gpsHeartbeat': 'Heartbeat GPS',
    'jk.portSwitch': 'Port (RS485)',
    'jk.lcdAlwaysOn': 'LCD zawsze włączony',
    'jk.specialCharger': 'Specjalna ładowarka',
    'jk.smartSleepEnabled': 'Inteligentne uśpienie',
    'jk.disablePCLModule': 'Wyłącz moduł PCL',
    'jk.timedStoredData': 'Czasowe przechowywanie danych',
    'jk.chargingFloatMode': 'Tryb podtrzymania ładowania',

    // Setting Types















    'settings.fullCharge': 'Ustawienia Pełnego Naładowania',
    'settings.cellSleep': 'Uśpienie Ogniwa',
    'settings.cellSleepDesc': 'Gdy napięcie ogniwa spadnie poniżej napięcia uśpienia przez czas dłuższy niż czas opóźnienia, bateria przejdzie w tryb uśpienia, aby oszczędzać energię.',
    'settings.inverterProtocol': 'Protokół Falownika',

    // InstallationSettings Main Page
    'settings.title': 'Ustawienia Instalacji',

    'settings.sendCommandFailed': 'Nie udało się wysłać komendy',
    'settings.confirmShutdown': 'Potwierdź Wyłączenie/Uśpienie',
    'settings.confirmShutdownDesc': 'Czy na pewno chcesz wyłączyć lub uśpić baterię? Po wyłączeniu musisz fizycznie przejść do instalacji baterii, aby ręcznie ją uruchomić.',

    // Tabs
    'settings.tabs.control': 'Sterowanie',
    'settings.tabs.protection': 'Ustaw. Ochrony',
    'settings.tabs.protocol': 'Protokół',
    'settings.tabs.system': 'System',
    'settings.tabs.log': 'Dziennik',

    // Messages
    'settings.messages.fetchingProtocolSettings': 'Pobieranie aktualnych ustawień protokołu...',
    'settings.messages.fetchProtocolListFailed': 'Nie udało się pobrać listy protokołów falownika',
    'settings.messages.fetchingHistory': 'Odczytywanie rekordów historii...',
    'settings.messages.startReadingHistory': 'Rozpoczynanie odczytu rekordów historii...',
    'settings.messages.readingHistoryProgress': 'Odczyt rekordu {{current}}/{{total}}...',
    'settings.messages.protocolSetSuccess': 'Protokół ustawiony pomyślnie',
    'settings.messages.protocolListSuccess': 'Lista protokołów pobrana pomyślnie',
    'settings.messages.protocolListComplete': 'Pobieranie listy protokołów zakończone! Znaleziono {{count}} protokołów',
    'settings.messages.protocolListCompleteCan': 'Pobieranie listy protokołów zakończone! Znaleziono {{count}} protokołów CAN',
    'settings.messages.fetchingProtocolIds': 'Pobieranie listy ID protokołów...',
    'settings.messages.fetchingCanNames': 'Pobieranie nazw protokołów CAN...',
    'settings.messages.fetchingRs485Names': 'Pobieranie nazw protokołów RS485...',



    // Support System
    'support.title': 'Wsparcie Techniczne',
    'support.newPost': 'Nowy Post',
    'support.editPost': 'Edytuj Post',
    'support.searchPlaceholder': 'Szukaj postów...',
    'support.filterByTag': 'Filtruj po Tagu',
    'support.allTags': 'Wszystkie Tagi',
    'support.products': 'Produkty',
    'support.categories': 'Kategorie',
    'support.sortBy': 'Sortuj Według',
    'support.sortLatest': 'Najnowsze',
    'support.sortPopular': 'Popularne',
    'support.sortUnsolved': 'Nierozwiązane',
    'support.sortMostViewed': 'Najczęściej Oglądane',
    'support.loadError': 'Błąd ładowania postów',
    'support.noSearchResults': 'Nie znaleziono pasujących postów',
    'support.noPosts': 'Brak postów',
    'support.createFirstPost': 'Utwórz pierwszy post',
    'support.minutesAgo': '{{count}} min temu',
    'support.hoursAgo': '{{count}} godz. temu',
    'support.daysAgo': '{{count}} dni temu',
    'support.pinned': 'Przypięty',
    'support.locked': 'Zablokowany',
    'support.resolved': 'Rozwiązany',
    'support.private': 'Prywatny',
    'support.views': 'Wyświetlenia',
    'support.replies': 'Odpowiedzi',
    'support.noReplies': 'Brak odpowiedzi',
    'support.backToList': 'Wróć do Listy',
    'support.postNotFound': 'Nie znaleziono postu',
    'support.accessDenied': 'Odmowa dostępu',
    'support.addReply': 'Dodaj Odpowiedź',
    'support.replyPlaceholder': 'Wpisz swoją odpowiedź...',
    'support.submitReply': 'Wyślij Odpowiedź',
    'support.loginToReply': 'Zaloguj się, aby odpowiedzieć',
    'support.postLocked': 'Post zablokowany, nie można odpowiadać',
    'support.bestAnswer': 'Najlepsza Odpowiedź',
    'support.markBestAnswer': 'Oznacz jako Najlepszą',
    'support.unmarkBestAnswer': 'Usuń Oznaczenie',
    'support.confirmDelete': 'Potwierdź Usunięcie',
    'support.confirmDeletePost': 'Czy na pewno chcesz usunąć ten post?',
    'support.confirmDeleteReply': 'Czy na pewno chcesz usunąć tę odpowiedź?',
    'support.pin': 'Przypnij',
    'support.unpin': 'Odepnij',
    'support.lock': 'Zablokuj',
    'support.unlock': 'Odblokuj',
    'support.statusOpen': 'Nierozwiązany',
    'support.statusResolved': 'Rozwiązany',
    'support.statusClosed': 'Zamknięty',
    'support.postTitle': 'Tytuł Postu',
    'support.titlePlaceholder': 'Krótko opisz swój problem',
    'support.postContent': 'Treść',
    'support.contentPlaceholder': 'Opisz szczegółowo swój problem lub sugestię...',
    'support.selectProduct': 'Wybierz Produkt',
    'support.noProduct': 'Brak',
    'support.selectCategory': 'Wybierz Kategorię',
    'support.categoryRequired': 'Wybierz kategorię',
    'support.announcementAdminOnly': 'Tylko admini mogą publikować ogłoszenia',
    'support.titleContentRequired': 'Tytuł i treść są wymagane',
    'support.linkDevice': 'Powiąż Urządzenie',
    'support.linkDeviceDescription': 'Powiąż urządzenie, aby udostępnić jego aktualny status i ustawienia personelowi wsparcia.',
    'support.selectDevice': 'Wybierz Urządzenie',
    'support.noDevice': 'Brak',
    'support.packIndex': 'Indeks Pakietu Baterii',
    'support.linkedDeviceSnapshot': 'Zrzut Statusu Urządzenia',
    'support.linkedDeviceSettings': 'Zrzut Ustawień Urządzenia',
    'support.publicPost': 'Post Publiczny',
    'support.privatePost': 'Post Prywatny',
    'support.publicDescription': 'Wszyscy mogą zobaczyć ten post',
    'support.privateDescription': 'Tylko Ty i admini mogą zobaczyć ten post',
    'support.submitPost': 'Wyślij Post',
    'support.saveDraft': 'Zapisz Wersję Roboczą',
    'support.draftSaved': 'Wersja robocza zapisana',
    'support.similarPostsFound': 'Znaleziono podobne posty, może już odpowiedziano:',
    'support.createError': 'Błąd tworzenia postu',

    // Phase 2 additions
    'support.myPosts': 'Moje Posty',
    'support.myPostsTab': 'Moje Posty',
    'support.draftsTab': 'Wersje Robocze',
    'support.noMyPosts': 'Jeszcze nic nie opublikowałeś',
    'support.untitledDraft': 'Wersja Robocza Bez Tytułu',
    'support.lastSaved': 'Ostatnio zapisano',
    'support.continueDraft': 'Kontynuuj Edycję',
    'support.deleteDraft': 'Usuń Wersję Roboczą',
    'support.noDrafts': 'Brak zapisanych wersji roboczych',
    'support.addImages': 'Dodaj Zdjęcia',
    'support.maxFilesError': 'Maksymalnie {{max}} zdjęć',
    'support.onlyImagesAllowed': 'Dozwolone tylko pliki obrazów',
    'support.fileTooLarge': 'Plik za duży (max 10MB)',
    'support.uploadFailed': 'Błąd wysyłania',
    'common.uploadImages': 'Wyślij Zdjęcia',

    // Phase 3 additions
    'support.mentioning': 'Wzmianka',

    // Phase 4 additions
    'support.adminPanel': 'Zarządz. Wsparciem',
    'support.tagsTab': 'Zarządz. Tagami',
    'support.templatesTab': 'Szablony Odpowiedzi',
    'support.reportsTab': 'Zarządz. Zgłoszeniami',
    'support.addTag': 'Dodaj Tag',
    'support.editTag': 'Edytuj Tag',
    'support.tagType': 'Typ Tagu',
    'support.tagColor': 'Kolor Tagu',
    'support.confirmDeleteTag': 'Czy na pewno chcesz usunąć ten tag?',
    'support.addTemplate': 'Dodaj Szablon',
    'support.editTemplate': 'Edytuj Szablon',
    'support.templateContent': 'Treść Szablonu',
    'support.templatePreview': 'Podgląd',
    'support.templatePlaceholder': 'Obsługuje format Markdown...',
    'support.noTemplates': 'Brak szablonów',
    'support.confirmDeleteTemplate': 'Czy na pewno chcesz usunąć ten szablon?',
    'support.useTemplate': 'Użyj Szablonu',
    'support.loadTemplatesError': 'Błąd ładowania szablonów',
    'support.filterStatus': 'Filtruj Status',
    'support.reportedContent': 'Zgłoszona Treść',
    'support.reportReason': 'Powód Zgłoszenia',
    'support.reporter': 'Zgłaszający',
    'support.reportPending': 'Oczekujące',
    'support.reportReviewed': 'Przejrzane',
    'support.reportDismissed': 'Odrzucone',
    'support.markReviewed': 'Oznacz jako Przejrzane',
    'support.dismissReport': 'Odrzuć Zgłoszenie',
    'support.noReports': 'Brak zgłoszeń',

    // API Keys
    'apiKeys.menuTitle': 'Klucze API',
    'apiKeys.title': 'Klucze API',
    'apiKeys.description': 'Zarządzaj kluczami dostępu dla integracji zewnętrznych',
    'apiKeys.usageWarning': 'Używaj kluczy API do uwierzytelniania aplikacji zewnętrznych, takich jak Home Assistant lub Grafana, bez konieczności logowania. Zachowaj swoje klucze w tajemnicy!',
    'apiKeys.myKeys': 'Moje Klucze',
    'apiKeys.generateKey': 'Generuj Klucz',
    'apiKeys.keyName': 'Nazwa',
    'apiKeys.created': 'Utworzony',
    'apiKeys.lastUsed': 'Ostatnie Użycie',
    'apiKeys.noKeys': 'Brak kluczy API',
    'apiKeys.integrationExamples': 'Przykłady Integracji',
    'apiKeys.haTitle': 'Home Assistant (REST Sensor)',
    'apiKeys.haInstructions': 'Dodaj to do swojego configuration.yaml:',
    'apiKeys.curlTitle': 'cURL / Terminal',
    'apiKeys.generateDialogTitle': 'Generuj Klucz API',
    'apiKeys.keyNameLabel': 'Nazwa Klucza (np. Home Assistant)',
    'apiKeys.generateAction': 'Generuj',
    'apiKeys.successDialogTitle': 'Klucz API Wygenerowany',
    'apiKeys.copyWarning': 'Skopiuj ten klucz teraz. Nie będziesz mógł go zobaczyć ponownie!',
    'apiKeys.createError': 'Błąd tworzenia klucza API',
    'apiKeys.deleteError': 'Błąd usuwania klucza',
    'apiKeys.loadError': 'Błąd ładowania kluczy API',

    // Ustawienia
    'settings.deleteAccount': 'Usuń konto',
    'settings.deleteAccountDesc': 'Po usunięciu konta nie ma już powrotu. Proszę, bądź pewny.',
    'settings.deleteAccountConfirm': 'Czy na pewno chcesz usunąć swoje konto?',
    'settings.deleteAccountWarning': 'Ta czynność jest stała i nie można jej cofnąć.',
    'settings.deleteAccountSuccess': 'Konto zostało pomyślnie usunięte',
  },
  // App specific
};

export default pl;
